import Api from 'src/api/Base'

class GetSspsaCommentsByCycleId extends Api {
  requestUrl = `/api/Cycle/${this.getParams().cycleId}/SspsaComments`
}

export default GetSspsaCommentsByCycleId
